/** @format */
const variable = {
  primaryColor: '#0091EA',
  borderColor: '#f0f0f0',
  successColor: '#40a54a',
  errorColor: 'rgb(255, 65, 51)',
  warningColor: '#ff8a00',
  fontColor: '#4c4c4c',
  disableColor: 'silver',
  greyBackground: '#f5f5f5',
  fontSmall: '12px',
  titleDefault: '14px'
}

export default variable
